import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import MotionWrapper from '../../component/MotionWrapper';
import Save_Date_Fall from '../../component/Fall/Save_Date_Fall';
import axios from 'axios';
import Info_Fall from '../../component/Fall/Info_Fall';
import Letter from '../../component/Spring/Letter';
import Dday_Spring from '../../component/Spring/Dday_Spring';
import Message_Spring from '../../component/Spring/Message_Spring';
import Location_Spring from '../../component/Spring/Location_Spring';
import Footer from '../../component/Footer';
import Loading from '../../component/Loading';
import Location_Desc from '../../component/Location/Location_Desc';
import Music from '../../component/Music';
import AccountList from '../../component/Account/AccountList';
import Sharing from '../../component/Sharing';
import GalleryList from '../../component/Gallery/GalleryList';
import Main_Fall from '../../component/Fall/Main_Fall';
import CallInfo from '../../component/CallInfo';
import ParentInfo from '../../component/Info/ParentInfo';

const JungDaHye = () => {
    const navigate = useNavigate(); 
    const { mainPage } = useParams();

    const API_URL = process.env.REACT_APP_API_URL;

    const [loading, setLoading] = useState(true);
    const [fontsLoaded, setFontsLoaded] = useState(false);

    const openTitle = "동우♥다혜 결혼식에 초대합니다.";
    const openDesc = "11월 1일 오후 5시";
    const openThumb = "https://d39wt6wnedokd1.cloudfront.net/265/thumb.jpg";
    
    // const parents = [
    //     {groom : "박삼용의 아들"},
    //     {bride : "최재선 · 김연순의 손녀"}
    // ] 

    const placeTelNum = "031-705-3033";

    const lng = 127.12246451531;
    const lat = 37.3873395397425;

    const forCar = "네비게이션 '경기도 성남시 분당구 서현로 180번길 19' 입력\n(판교 톨게이트 2.5km 직진 5분소요)"
    const forBus = "서현역, AK프라자, 이매촌한신아파트 하차 (도보 5분)";
    const forSubway = "분당선 서현역 5번출구 좌측 (도보5분)";
    const forParking = "웨딩홀 내 주차타워 이용 가능 (2시간 30분 무료)"


    const [weddingData, setWeddingData] = useState({
        id:'',
        concept: '',
        weddingDate: '',
        invitationInfoId: '',
        brideName: '',
        groomName: '',
        brideNameEn: '',
        groomNameEn: '',
        year:'',
        month:'',
        date:'',
        dayOfWeek:'',
        time:'',
        place:'',
        address:'',
        mainImg:'',
        subImg:'',
        pointColor: '',
        btnFontColor: '',
        btnBgColor: '',
        isGuestBookOpen: ''
    });

    // #80041A
    const conceptStyle = {
        concept: "FALL",
        titleColor: "#000000",
        pointColor: "#80041A",
        btnBgColor: "#80041A",
        fontColor: "#000000",
        btnFontColor: "#ffffff",
        chatBgColor: "#F4F4F4",
        fontFamilyKo: "JejuMyeongjo",
        fontFamilyEn: "Milchella"
    }

    const title = "저희 결혼합니다."

    const msg1 = "만남에 사랑이 스며들어 저희 두 사람,\n사랑의 결실을 이루려 합니다.";
    const msg2 = "언제나처럼 평생의 연인이자\n서로에게 유일한 사랑으로 머물겠습니다.";
    const msg3 = "가장 행복하고 아름다운 순간, 소중한 분들을 초대합니다.";

    const groomAccountList = [
        {
            role: "신랑",
            name: "한동우",
            bank: "국민은행",
            accountNumber : "853002-00-035550",
            isKakao : true,
            kakakoUrl : "https://qr.kakaopay.com/FTFWIFQc3"
        }
        ,{
            role: "신랑 부",
            name: "한승민",
            bank: "국민은행",
            accountNumber : "463502-01-134576",
            isKakao : false
        },
        {
            role: "신랑 모",
            name: "한경인",
            bank: "우리은행",
            accountNumber : "100-26433-14-094",
            isKakao : false
        }
    ]

    const brideAccountList = [
        {
            role: "신부",
            name: "정다혜",
            bank: "국민은행",
            accountNumber : "637402-01-848975",
            isKakao : true,
            kakaoUrl: "https://qr.kakaopay.com/Ej9M7gTy6"
        }
        ,{
            role: "신부 부",
            name: "정준철",
            bank: "기업은행",
            accountNumber : "341-051375-01-011",
            isKakao : false
        }
        ,{
            role: "신부 모",
            name: "송미숙",
            bank: "국민은행",
            accountNumber : "584102-01-474797",
            isKakao : false
        }
    ]

    const groomCallInfoList = [
        {
            role: "신랑",
            name: "한동우",
            call: "010-5699-3827"
        }
        ,{
            role: "신랑 부",
            name: "한승민",
            call: "010-3663-3115"
        },
        {
            role: "신랑 모",
            name: "한경인",
            call: "010-2447-3829"
        }
    ]
    
    const brideCallInfoList = [
        {
            role: "신부",
            name: "정다혜",
            call: "010-3272-7540"
        }
        ,{
            role: "신부 부",
            name: "정준철",
            call: "010-9779-7540"
        },
        {
            role: "신부 모",
            name: "송미숙",
            call: "010-6449-7540"
        }
    ]

    const parentInfo = {
        groom: {
            dad: { name: "박삼용", isDeceased: false },
            // mom: { name: "", isDeceased: false },
            role: "장남",
        },
        bride: {
            dad: { name: "최명성", isDeceased: false },
            // mom: { name: "", isDeceased: false },
            role: "장녀",
        }
    };


    const account_explain = "따로 계좌번호를 여쭤보시는 수고를 덜기 위해 기입합니다. \n부담 안가지셨으면 좋겠습니다."

    const fetchInvitationInfoData = async () => {
        try {
            const response = await axios.get(`${API_URL}/_api/v1/invitation_info/${mainPage}`);
            if(response.status === 200){
                const [y, m, d] = response.data.data.weddingDate.split('-');

                setWeddingData(prevData => {
                    const newData = {
                        id: response.data.data.id,
                        concept: response.data.data.concept,
                        weddingDate: response.data.data.weddingDate,
                        invitationInfoId: response.data.data.id,
                        brideName: response.data.data.brideNameKo,
                        groomName: response.data.data.groomNameKo,
                        brideNameEn: response.data.data.brideNameEn,
                        groomNameEn: response.data.data.groomNameEn,
                        year: y,
                        month: m,
                        date: d,
                        dayOfWeek: response.data.data.dayOfWeek,
                        time: response.data.data.time,
                        place: response.data.data.place,
                        address: response.data.data.address,
                        mainImg: response.data.data.mainImg,
                        subImg: response.data.data.subImg,
                        pointColor: response.data.data.pointColor,
                        btnBgColor: response.data.data.btnBgColor,
                        btnFontColor: response.data.data.btnFontColor,
                        isGuestBookOpen: response.data.data.isGuestBookOpen
                    };
                    return newData;
                });
            } 
        } catch (error) {
            console.error("API 요청 실패:", error.response ? error.response.data : error.message);
        }
    };

    useEffect(() => {
        const fetchDataSequentially = async () => {
            if (!weddingData.weddingDate) {  
                await fetchInvitationInfoData();
            }
        };
        fetchDataSequentially();  
    
        document.body.style.overflow = 'hidden';
    
        const timer = setTimeout(() => {
            document.body.style.overflow = '';
        }, 3000);
    
        return () => {
            clearTimeout(timer);
            document.body.style.overflow = '';
        };
    }, []);

    useEffect(() => {
        const fontLoadObserver = async () => {
            await document.fonts.ready; 
            setFontsLoaded(true); 
            setLoading(false);
        };
        if(!weddingData.weddingDate){
            fontLoadObserver();
        }
    }, []);

    const goToGuestBook = () => {
        navigate(`/${mainPage}/guest`); 
    };

    // 성을 제외하고 이름만 추출 ex. 가영
    const getFirstKoName = (fullName) => {
        const nameParts = fullName.split(''); 
        return nameParts.slice(1).join(''); 
    };

    // 성을 제외하고 이름만 추출 ex.Gayeong
    const getFirstNameEn = (fullName) => {
        const nameParts = fullName.split(' '); 
        const firstName = nameParts.slice(1).join(''); 
        return firstName.charAt(0).toUpperCase() + firstName.slice(1).toLowerCase();
    };

    const toLowerCaseString = (str) => {
        const parts = str.split(" ");
        if (parts.length < 2) return str; // 성과 이름이 없으면 그대로 반환
        const firstName = parts[1] + (parts[2] || ""); // 이름 부분 결합
        const formattedFirstName = firstName.charAt(0).toUpperCase() + firstName.slice(1).toLowerCase(); // 이름의 첫 글자만 대문자로 변환
        return `${parts[0]} ${formattedFirstName}`;
    };

    return (
        <div>
            {loading || !fontsLoaded ? (
                <Loading color={"#80041A"} loading={loading} />
            ) : (
                <>
                    <Music concept={conceptStyle.concept}/>
                    <Main_Fall brideNameEn={toLowerCaseString(weddingData.groomNameEn)} groomNameEn={toLowerCaseString(weddingData.brideNameEn)} weddingData={weddingData} conceptStyle={conceptStyle}/>
                    <Save_Date_Fall weddingData={weddingData} color={conceptStyle.pointColor} />
                    <Info_Fall weddingData={weddingData} conceptStyle={conceptStyle} />
                    <Letter title={title} msg1={msg1} msg2={msg2} msg3={msg3} conceptStyle={conceptStyle} />
                    {/* <MotionWrapper initialY={70}>
                        <ParentInfo conceptStyle={conceptStyle} parentInfo={parentInfo} weddingData={weddingData}/>
                    </MotionWrapper> */}
                    <CallInfo marginTop={"20px"} conceptStyle={conceptStyle} groomCallInfoList={groomCallInfoList} brideCallInfoList={brideCallInfoList}/>
                    <Dday_Spring groomName={getFirstKoName(weddingData.brideName)} brideName={getFirstKoName(weddingData.groomName)} weddingData={weddingData} conceptStyle={conceptStyle}/>
                    <MotionWrapper initialY={50}>
                        <GalleryList fontFamilyKo={conceptStyle.fontFamilyKo} fontFamilyEn={conceptStyle.fontFamilyEn} color={conceptStyle.titleColor} weddingData={weddingData} initCount={9} photoWidth={"110px"} photoHeight={"150px"} gap={"4px"}/>
                    </MotionWrapper>
                    <MotionWrapper initialY={70}>
                        <AccountList conceptStyle={conceptStyle} groomAccountList={groomAccountList} brideAccountList={brideAccountList} account_explain={account_explain} />
                    </MotionWrapper>
                    <MotionWrapper initialY={70}>
                        <Message_Spring weddingData={weddingData} goToGuestBook={goToGuestBook} weddingDate={weddingData.weddingDate} 
                            conceptStyle={conceptStyle} 
                            btnBgColor={weddingData.btnBgColor} btnFontColor={weddingData.btnFontColor} titleColor={weddingData.titleColor}
                            />
                    </MotionWrapper>
                    <MotionWrapper initialY={50}>
                        <Location_Spring weddingData={weddingData} conceptStyle={conceptStyle} lng={lng} lat={lat} placeTelNum={placeTelNum}/>
                    </MotionWrapper>
                        <Location_Desc forCar={forCar} forSubway={forSubway} forBus={forBus} forParking={forParking} conceptStyle={conceptStyle}/>
                        <Sharing conceptStyle={conceptStyle} title={openTitle} description={openDesc} thumbImg={openThumb}/>
                        <Footer />
                </>
            )}
        </div>
    );
    
};

export default JungDaHye;